module.exports = __webpack_public_path__ + "static/media/公文管理.d8978271.png";